import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardPage from 'pages/core/DashboardPage/DashboardPage';
import MainPage from 'pages/core/MainPage/MainPage';
import CreateRegistryPage from 'pages/registries/CreateRegistryPage/CreateRegistryPage';
import AllRegistriesPage from 'pages/registries/AllRegistriesPage/AllRegistriesPage';
import MyRegistriesPage from 'pages/registries/MyRegistriesPage/MyRegistriesPage';
import SharedRegistreisPage from 'pages/registries/SharedRegistreisPage/SharedRegistreisPage';
import CaseDetailsPage from 'pages/case/CaseDetailsPage/CaseDetailsPage';
import AddCasePage from 'pages/case/AddCasePage/AddCasePage';
import AllPatientsPage from 'pages/case/AllPatientsPage/AllPatientsPage';
import RVUsCalculatorPage from 'pages/core/RVUsCalculatorPage/RVUsCalculatorPage';
import ContactUs from 'pages/auth/contactUs/ContactUs';
import UsersPage from 'pages/core/UsersPage/UsersPage';
import ProfilePage from 'pages/user/ProfilePage/ProfilePage';
import CurrentPlanPage from 'pages/user/CurrentPlanPage/CurrentPlanPage';
import NotificationsPage from 'pages/core/NotificationsPage/NotificationsPage';
import RegistryPage from 'pages/registries/RegistryPage/RegistryPage';
import AddRegistryPatientPage from 'pages/registries/AddRegistryPatientPage/AddRegistryPatientPage';
import RegistryPatientDetailsPage from 'pages/registries/RegistryPatientDetailsPage/RegistryPatientDetailsPage';
import VerifyRegistrySharing from 'pages/registries/VerifyRegistrySharing/VerifyRegistrySharing';
import RegistryCollaboratorsPage from 'pages/registries/RegistryCollaboratorsPage/RegistryCollaboratorsPage';
import RegistryInvitationsPage from 'pages/registries/RegistryInvitationsPage/RegistryInvitationsPage';
import PrivacyPage from 'pages/auth/PrivacyPage/PrivacyPage';
import TermsPage from 'pages/auth/TermsPage/TermsPage';
import AccountDeletionPage from 'pages/auth/AccountDeletionPage/AccountDeletionPage';
import DashboardInvitationRedirectPage from 'pages/core/DashboardInvitationRedirectPage/DashboardInvitationRedirectPage';

export default function UserRoutes() {
  return (
    <Routes>
      <Route path="/" element={<MainPage />}>
        <Route index element={<Navigate to="dashboard" replace />} />

        <Route path="dashboard" element={<DashboardPage />} />

        <Route path="patients/all-patients" element={<AllPatientsPage />} />
        <Route path="patients/add" element={<AddCasePage />} />
        <Route path="patients/:patientId" element={<CaseDetailsPage />} />
        <Route path="patients/:patientId/edit" element={<AddCasePage />} />

        <Route path="registries/all-registries" element={<AllRegistriesPage />} />
        <Route path="registries/my-registries" element={<MyRegistriesPage />} />
        <Route path="registries/shared-registries" element={<SharedRegistreisPage />} />
        <Route path="registries/new-registry" element={<CreateRegistryPage />} />
        <Route path="registries/:registryId" element={<RegistryPage />} />

        <Route path="registries/all-registries/:registryId/patients/add" element={<AddRegistryPatientPage />} />
        <Route path="registries/my-registries/:registryId/patients/add" element={<AddRegistryPatientPage />} />
        <Route path="registries/shared-registries/:registryId/patients/add" element={<AddRegistryPatientPage />} />

        <Route path="registries/all-registries/:registryId/patients/:patientId" element={<RegistryPatientDetailsPage />} />
        <Route path="registries/my-registries/:registryId/patients/:patientId" element={<RegistryPatientDetailsPage />} />
        <Route path="registries/shared-registries/:registryId/patients/:patientId" element={<RegistryPatientDetailsPage />} />

        <Route path="registries/all-registries/:registryId/patients/:patientId/edit" element={<AddRegistryPatientPage />} />
        <Route path="registries/my-registries/:registryId/patients/:patientId/edit" element={<AddRegistryPatientPage />} />
        <Route path="registries/shared-registries/:registryId/patients/:patientId/edit" element={<AddRegistryPatientPage />} />

        <Route path="registries/all-registries/:registryId/invitations" element={<RegistryInvitationsPage />} />
        <Route path="registries/my-registries/:registryId/invitations" element={<RegistryInvitationsPage />} />

        <Route path="registries/all-registries/:registryId/edit" element={<CreateRegistryPage />} />
        <Route path="registries/my-registries/:registryId/edit" element={<CreateRegistryPage />} />

        <Route path="registries/all-registries/:registryId/collaborators" element={<RegistryCollaboratorsPage />} />
        <Route path="registries/my-registries/:registryId/collaborators" element={<RegistryCollaboratorsPage />} />

        <Route path="registries/all-registries/:registryId" element={<RegistryPage />} />
        <Route path="registries/my-registries/:registryId" element={<RegistryPage />} />
        <Route path="registries/shared-registries/:registryId" element={<RegistryPage />} />

        <Route path="registries/all-registries/:registryId/patients/:patientId" element={<RegistryPatientDetailsPage />} />
        <Route path="registries/my-registries/:registryId/patients/:patientId" element={<RegistryPatientDetailsPage />} />
        <Route path="registries/shared-registries/:registryId/patients/:patientId" element={<RegistryPatientDetailsPage />} />


        <Route path="registries/:registryId/verification/:code" element={<VerifyRegistrySharing />} />

        <Route path="rvus-calculator" element={<RVUsCalculatorPage />} />



        <Route path="users" element={<UsersPage />} />

        <Route path="contact" element={<ContactUs />} />

        <Route path="dashboard/:userId/invitation/:code/:key" element={<DashboardInvitationRedirectPage />} />

        <Route path="profile" element={<ProfilePage />} />

        <Route path="my-plan" element={<CurrentPlanPage />} />

        <Route path="notifications" element={<NotificationsPage />} />

        <Route path="privacy" element={<PrivacyPage />} />
        <Route path="terms" element={<TermsPage />} />
        <Route path="account-deletion" element={<AccountDeletionPage />} />

      </Route>

      {/* fallback for unknown routes */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
